document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    if (sessionStorage.getItem("openCheckout")) {
      sessionStorage.removeItem("openCheckout");
      document.querySelector("marmeto-checkout-button").click();
    }
  }, 1000);
  document.addEventListener("dispatch:checkout:open", () => {
    document.dispatchEvent(
      new CustomEvent("dispatch:cart-drawer:open", {
        bubbles: true,
        cancelable: false,
      }),
    );
    document.querySelector("marmeto-checkout-button").click();
  });
});

function detectWebview(platform = false) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS WebView Detection
  const isIOS = /iPhone|iPod|iPad/.test(userAgent);
  const isSafari =
    /Safari/.test(userAgent) || /CriOS|FxiOS|EdgiOS/.test(userAgent); // Exclude Chrome, Firefox, Edge
  const isIOSWebView =
    isIOS &&
    !isSafari &&
    (navigator.standalone === false || /AppleWebKit/.test(userAgent));

  // Android WebView Detection
  const isAndroid = /Android/.test(userAgent);
  const isAndroidWebView =
    (isAndroid && /wv/.test(userAgent)) ||
    (isAndroid &&
      /Version\/\d+\.\d+/.test(userAgent) &&
      !/Chrome/.test(userAgent));

  // React Native WebView Detection
  const isReactNativeWebView = !!window.ReactNativeWebView;
  // console.log("isIOSWebView", isIOSWebView, "isAndroidWebView", isAndroidWebView, "isReactNativeWebView", isReactNativeWebView);

  return platform
    ? {
        android: isAndroidWebView,
        isWebview: isIOSWebView || isAndroidWebView || isReactNativeWebView,
      }
    : isIOSWebView || isAndroidWebView || isReactNativeWebView;
}

class SsoLogin extends HTMLElement {
  static activeInstance = null;
  constructor() {
    super();
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.togglePopupHandler = this.togglePopup.bind(this);
    this.isPopupOpen = false;
  }

  connectedCallback() {
    this.addEventListener("click", this.togglePopupHandler);

    const closeButton = document.querySelector("sso-close-button");
    const phoneUpdateCloseButton = document.querySelector(
      "phone-update-close-button",
    );
    const modalOverlay = document.querySelector("modal-overlay");

    [closeButton, phoneUpdateCloseButton, modalOverlay].forEach(
      this.attachCloseHandler.bind(this),
    );
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.togglePopupHandler);

    const closeButton = document.querySelector("sso-close-button");
    const phoneUpdateCloseButton = document.querySelector(
      "phone-update-close-button",
    );
    const modalOverlay = document.querySelector("modal-overlay");

    [closeButton, phoneUpdateCloseButton, modalOverlay].forEach(
      this.detachCloseHandler.bind(this),
    );
  }

  attachCloseHandler(element) {
    if (element) {
      element.addEventListener("click", this.togglePopupHandler);
    }
  }

  detachCloseHandler(element) {
    if (element) {
      element.removeEventListener("click", this.togglePopupHandler);
    }
  }

  clearSessionStorage(key) {
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

  clearInputs() {
    document.querySelector('phone-login input[name="phone-number"]').value = "";
    const otpHolders = Array.from(document.querySelectorAll(".otp--holder"));
    const otpValidationInput = document.getElementById("otp-validation-input");

    const phoneLoginContinueBtn = document.querySelector(
      "phone-login .continue--button",
    );
    const otpConfirmBtn = document.querySelector("otp-confirm-button");

    if (!this.otpDigits || this.otpDigits.length !== otpHolders.length) {
      this.otpDigits = new Array(otpHolders.length).fill("");
    }

    otpHolders.forEach((holder, index) => {
      holder.textContent = "";
      this.otpDigits[index] = "";
    });

    otpConfirmBtn.setAttribute("disabled", "true");

    otpValidationInput.value = "";
    phoneLoginContinueBtn.setAttribute("disabled", "true");
  }

  togglePopup(event) {
    event?.preventDefault();

    const popup = document.querySelector("sso-login-popup");
    if (popup) {
      if (this.isPopupOpen) {
        popup.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        this.isPopupOpen = false;
        SsoLogin.activeInstance = null; // Clear the active instance
      } else {
        if (SsoLogin.activeInstance && SsoLogin.activeInstance !== this) {
          SsoLogin.activeInstance?.closePopup();
        }

        popup.classList.add("active");
        document.dispatchEvent(new CustomEvent("event:login:init"));
        document.querySelector("sso-login-container")?.initListeners();
        document.body.classList.add("overflow-hidden");
        this.clearSessionStorage("openCheckout");
        this.clearInputs();

        if (popup.classList.contains("active") && this.isAndroid) {
          this.checkAndOpenTruecaller();
        }

        this.isPopupOpen = true;
        SsoLogin.activeInstance = this;
      }
      // if it's login page or register page then redirect to homepage on popup close
      if (
        !popup.classList.contains("active") &&
        ["/account/login", "/account/register"].some((path) =>
          window.location.pathname.includes(path),
        )
      ) {
        window.location.href = "/";
      }
    }
  }

  checkAndOpenTruecaller() {
    let isTruecallerInstalled = false;
    const truecallerURL = "truecaller://";
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = truecallerURL;
    document.body.appendChild(iframe);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (isTruecallerInstalled) {
          const truecallerLoginElement =
            document.querySelector("truecaller-login");
          truecallerLoginElement?.onSubmit();
        }
        document.body.removeChild(iframe);
      }, 500);
    });

    window.addEventListener(
      "blur",
      () => {
        isTruecallerInstalled = true;
      },
      { once: true },
    );
  }
}

customElements.define("sso-login", SsoLogin);

class SsoLoginContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add("active");
    this.initListeners();
  }

  initListeners() {
    const phoneLoginForm = this.querySelector("phone-login > form");
    const socialLogin = this.querySelector("social-login");
    const alternativeSocialLogin = this.querySelector(
      "alternative-social-login",
    );
    const alternativePhoneLogin = this.querySelector("alternative-phone-login");

    if (
      phoneLoginForm &&
      socialLogin &&
      alternativeSocialLogin &&
      alternativePhoneLogin
    ) {
      // Set initial states
      this.setDisplayStyles(
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        true,
      );

      // Add event listeners for toggling login forms
      this.addToggleListener(
        alternativeSocialLogin,
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        false,
      );
      this.addToggleListener(
        alternativePhoneLogin,
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        true,
      );
    }
  }

  setDisplayStyles(
    phoneLogin,
    socialLogin,
    altSocialLogin,
    altPhoneLogin,
    isPhoneLoginActive,
  ) {
    phoneLogin.style.display = isPhoneLoginActive ? "flex" : "none";
    socialLogin.style.display = isPhoneLoginActive ? "none" : "flex";
    altSocialLogin.style.display = isPhoneLoginActive ? "inline-flex" : "none";
    altPhoneLogin.style.display = isPhoneLoginActive ? "none" : "inline-flex";
  }

  addToggleListener(
    toggleElement,
    phoneLogin,
    socialLogin,
    altSocialLogin,
    altPhoneLogin,
    isPhoneLoginActive,
  ) {
    toggleElement.addEventListener("click", () => {
      this.setDisplayStyles(
        phoneLogin,
        socialLogin,
        altSocialLogin,
        altPhoneLogin,
        isPhoneLoginActive,
      );
    });
  }
}

customElements.define("sso-login-container", SsoLoginContainer);

class SsoLoginValidations extends HTMLElement {
  constructor() {
    super();
    this.errorToast = null;
    this.successToast = null;
  }

  connectedCallback() {
    this.errorToast = this.querySelector("login-error-toast");
    this.successToast = this.querySelector("login-success-toast");
  }

  showToast(type, message) {
    const toastElement =
      type === "success" ? this.successToast : this.errorToast;
    const messageElement = toastElement.querySelector(
      type === "success" ? "success-message" : "error-message",
    );

    messageElement.textContent = message;
    this.classList.add("active");
    toastElement.classList.add("active");
    this.animateToast(toastElement);
  }

  animateToast(toastElement) {
    const progressBar = toastElement.querySelector("toast-progress-bar");
    progressBar.style.width = "100%";

    requestAnimationFrame(() => {
      progressBar.style.transition = "width 3s linear";
      progressBar.style.width = "0%";
    });

    setTimeout(() => {
      this.hideToast(toastElement);
    }, 3000);
  }

  hideToast(toastElement) {
    toastElement.classList.remove("active");
    this.classList.remove("active");
    const progressBar = toastElement.querySelector("toast-progress-bar");
    progressBar.style.transition = "";
    progressBar.style.width = "100%";
  }

  showSuccessToast(message) {
    this.showToast("success", message);
  }

  showErrorToast(message) {
    this.showToast("error", message);
  }
}

customElements.define("sso-login-validations", SsoLoginValidations);

class PhoneLogin extends HTMLElement {
  constructor() {
    super();
    this.phoneNumber = "";
    this.countryCode = "";
    this.sessionId = "";
    this.validationsElement = null;
  }

  connectedCallback() {
    this.initPhoneLogin();
  }

  initPhoneLogin() {
    this.validationsElement = document.querySelector("sso-login-validations");
    const inputField = this.querySelector('input[name="phone-number"]');
    const continueButton = this.querySelector(".phone-login-button");
    const captchaButton = document.getElementById("captcha-button");
    const otpOnCallButton = document.querySelector("otp-on-call");

    this.disableButton(continueButton);
    inputField.addEventListener("input", () =>
      this.validatePhoneNumber(inputField, continueButton),
    );

    continueButton.addEventListener("click", (event) =>
      this.handleContinueClick(event, captchaButton, continueButton),
    );
    otpOnCallButton.addEventListener("click", (event) =>
      this.handleOtpOnCall(event, captchaButton),
    );
  }

  handleContinueClick(event, captchaButton, continueButton) {
    event.preventDefault();
    document.dispatchEvent(
      new CustomEvent("event:login:start", {
        detail: {
          method: "phone",
          phone: this.phoneNumber,
        },
      }),
    );
    this.toggleButtonState(continueButton, true);
    this.countryCode = this.querySelector(
      'input[name="countryCode"]',
    ).value.trim();

    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.sendOtpRequest(captchaButton, "send");
    } else {
      this.showError("Invalid phone number.", continueButton);
    }
  }

  handleOtpOnCall(event, captchaButton) {
    event.preventDefault();
    this.sendOtpRequest(captchaButton, "call");
  }

  sendOtpRequest(captchaButton, otpType) {
    captchaButton.setAttribute("data-otp-type", otpType);
    captchaButton.click();
  }

  validatePhoneNumber(inputField, continueButton) {
    this.phoneNumber = inputField?.value.trim();
    console.log("Phone Number:", this.phoneNumber);
    console.log("Country Code:", this.countryCode);
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.enableButton(continueButton);
    } else {
      this.disableButton(continueButton);
    }
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  async handleRecaptchaToken(token) {
    const captchaButton = document.getElementById("captcha-button");
    const otpType = captchaButton.getAttribute("data-otp-type") || "send";

    try {
      await this.callApi(this.phoneNumber, token, this.countryCode, otpType);
    } catch (error) {
      console.error("ReCAPTCHA validation failed:", error);
      this.validationsElement.showErrorToast("ReCAPTCHA validation failed.");
      this.toggleButtonState(".phone-login-button", false);
    } finally {
      captchaButton.removeAttribute("data-otp-type");
    }
  }
  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();
      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }
  async callApi(phone, captcha, countryCode, otpType) {
    otpType = otpType || "sms";
    const continueButton = this.querySelector(".phone-login-button");

    const customerSession = await this.getCustomerSession();
    const shopifyYCookie = getCookie("_shopify_y");
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Device-ID": shopifyYCookie ?? "",
      },
      body: JSON.stringify({
        phone,
        countryCode,
        captcha,
        medium: otpType,
        cfUserId: customerSession?.cfUserId,
      }),
    };

    try {
      let url = "";
      if (!customerSession?.customer) {
        url = "https://tesseract.cultstore.com/phone/otp/send";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        const cfUserId = customerSession?.cfUserId;
        url = "https://tesseract.cultstore.com/phone/update/otp/send";
      } else {
        // todo:: log and report error here
        return;
      }
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(
          data.error || data.message || "Error occurred during OTP request.",
        );
      }
      this.sessionId = data?.data?.session_id || "";

      this.toggleButtonState(continueButton, false);
      this.handleOtpSuccess(otpType);
    } catch (error) {
      console.error("Error during OTP request:", error);
      this.validationsElement.showErrorToast(error.message);
      this.toggleButtonState(continueButton, false);
    }
  }

  handleOtpSuccess(otpType) {
    let successMessage = "";
    switch (otpType) {
      case "resend":
        successMessage =
          "OTP has been resent to your phone number. Please check!";
        break;
      case "call":
        successMessage = "You will receive OTP on call shortly!";
        break;
      case "send":
      default:
        successMessage = "OTP sent successfully!";
        break;
    }
    this.validationsElement.showSuccessToast(successMessage);
    this.navigateToOtp(this.phoneNumber, this.sessionId);
  }

  toggleButtonState(button, isLoading) {
    button.classList.toggle("is-loading", isLoading);
  }

  disableButton(button) {
    button?.setAttribute("disabled", "true");
  }

  enableButton(button) {
    button?.removeAttribute("disabled");
  }

  showError(message, button) {
    this.validationsElement.showErrorToast(message);
    this.toggleButtonState(button, false);
  }

  navigateToOtp(phoneNumber, sessionId) {
    const ssoLoginContainer = document.getElementById("sso-login-container");
    const ssoLoginOtp = document.querySelector("sso-login-otp");
    const otpOnCallElement = document.querySelector("otp-on-call");
    const otpTimerElement = document.querySelector("otp-timer");

    if (ssoLoginContainer && ssoLoginOtp) {
      ssoLoginContainer.classList.remove("active");
      ssoLoginOtp.classList.add("active");
      this.querySelector('input[name="phone-number"]').value = "";

      ssoLoginOtp.setPhoneNumber(phoneNumber, sessionId);
      if (otpOnCallElement && otpTimerElement) {
        this.otpTimerCountdown(15, otpTimerElement, otpOnCallElement);
      }
    }
  }

  otpTimerCountdown(duration, otpTimerElement, getOtpOnCallButton) {
    let timeLeft = duration;
    this.disableButton(getOtpOnCallButton);

    const intervalId = setInterval(() => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      otpTimerElement.textContent = ` in ${minutes < 10 ? "0" : ""}${minutes}:${
        seconds < 10 ? "0" : ""
      }${seconds}`;

      if (timeLeft <= 0) {
        clearInterval(intervalId);
        otpTimerElement.textContent = "";
        this.enableButton(getOtpOnCallButton);
      }

      timeLeft--;
    }, 1000);
  }
}

customElements.define("phone-login", PhoneLogin);

class SsoLoginOtp extends HTMLElement {
  constructor() {
    super();
    this.otpDigits = [];
    this.sessionId = "";
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.initOtpListeners();
    const otpValidationInput = document.getElementById("otp-validation-input");
    if (otpValidationInput) {
      otpValidationInput.focus(); // Ensure hidden input is the autofill target
    }
  }

  initOtpListeners() {
    const backButton = this.querySelector(".back--button");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById("otp-validation-input");
    const confirmButton = this.querySelector(".otp--confirm__button");
    const getHelpLink = this.querySelector(".get--help__link");

    otpHolders.forEach((holder, index) =>
      this.setupOtpHolder(holder, index, otpHolders, otpValidationInput),
    );

    // Listen for input events on the hidden input for autofill handling
    otpValidationInput.addEventListener("input", () =>
      this.handleOtpAutofill(otpValidationInput, otpHolders),
    );

    backButton?.addEventListener("click", this.handleBackButton.bind(this));
    confirmButton?.addEventListener(
      "click",
      this.handleConfirmButton.bind(this),
    );
    getHelpLink?.addEventListener("click", this.handleGetHelpLink.bind(this));
  }

  setupOtpHolder(holder, index, otpHolders, otpValidationInput) {
    holder.setAttribute("inputmode", "numeric");
    holder.setAttribute("autocomplete", "one-time-code");
    holder.style.caretColor = "black";
    holder.style.cursor = "text";

    holder.addEventListener("input", (event) =>
      this.handleOtpInput(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("keydown", (event) =>
      this.handleOtpBackspace(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("paste", (event) =>
      this.handleOtpPaste(event, otpHolders, otpValidationInput),
    );
  }

  handleOtpAutofill(otpValidationInput, otpHolders) {
    const otp = otpValidationInput.value.trim();
    if (/^\d{6}$/.test(otp)) {
      this.otpDigits = otp.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last field for UX
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpPaste(event, otpHolders, otpValidationInput) {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    if (/^\d{6}$/.test(paste)) {
      this.otpDigits = paste.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus();
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpInput(event, index, otpHolders, otpValidationInput) {
    const input = event.target.value.trim();

    if (index === 0 && /^\d{6}$/.test(input)) {
      // If the first input receives a 6-digit OTP (autofill case), distribute it
      this.otpDigits = input.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last input for UX
    } else if (/^\d$/.test(input)) {
      // If the input is a single digit, handle it normally
      this.otpDigits[index] = input;
      if (index < otpHolders.length - 1) {
        otpHolders[index + 1].focus(); // Move focus to the next field
      }
    } else {
      // If the input is invalid, clear the field
      event.target.value = "";
      this.otpDigits[index] = "";
    }

    this.updateOtpValue(otpValidationInput);
  }

  handleOtpBackspace(event, index, otpHolders, otpValidationInput) {
    if (event.key === "Backspace") {
      if (event.target.value) {
        event.target.value = "";
        this.otpDigits[index] = "";
      } else if (index > 0) {
        otpHolders[index - 1].focus();
        otpHolders[index - 1].value = "";
        this.otpDigits[index - 1] = "";
      }
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleBackButton() {
    const ssoLoginContainer = document.getElementById("sso-login-container");
    const phoneLogin = document.querySelector("phone-login");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById("otp-validation-input");
    const phoneLoginInputField = document.getElementById("phone-number");
    const phoneLoginContinueButton = document.querySelector(
      ".phone-login-button",
    );

    if (ssoLoginContainer) {
      ssoLoginContainer.classList.add("active");
      this.classList.remove("active");
      phoneLogin?.validatePhoneNumber(
        phoneLoginInputField,
        phoneLoginContinueButton,
      );

      this.otpDigits = this.otpDigits || new Array(otpHolders.length).fill("");
      otpHolders.forEach((holder, index) => {
        holder.value = "";
        this.otpDigits[index] = "";
      });
      otpValidationInput.value = "";
      this.toggleConfirmButton(true);
    }
  }

  handleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    if (confirmButton.hasAttribute("disabled")) return;

    confirmButton.classList.add("is-loading");
    document.querySelector("#verify-otp-form .g-recaptcha").click();
  }

  setPhoneNumber(phoneNumber, sessionId) {
    const otpPhoneElement = this.querySelector("otp-phone");
    if (otpPhoneElement) otpPhoneElement.textContent = phoneNumber;

    this.sessionId = sessionId;
  }

  updateOtpValue(otpValidationInput) {
    otpValidationInput.value = this.otpDigits.join("");
    this.toggleConfirmButton();
  }

  toggleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    const otpValidationInput = document.getElementById("otp-validation-input");

    if (otpValidationInput.value.length === 6) {
      confirmButton.removeAttribute("disabled");
    } else {
      confirmButton.setAttribute("disabled", "true");
    }
  }

  async callVerifyApi(otp, captcha, sessionId, return_to) {
    const customerSession = await this.getCustomerSession();
    try {
      let url = "";
      if (!customerSession?.customer) {
        url = "https://tesseract.cultstore.com/phone/otp/verify";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        url = "https://tesseract.cultstore.com/phone/update/otp/verify";
      } else {
        // todo:: log and report error here
        return;
      }
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Device-ID": shopifyYCookie ?? "",
        },
        body: JSON.stringify({
          otp,
          captcha,
          sessionId,
          return_to,
          cfUserId: customerSession?.cfUserId,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error("Network response was not ok");

      if (data.success) {
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        document.dispatchEvent(
          new CustomEvent("event:login:otp", {
            detail: {
              method: "phone",
              phone: this.phoneNumber,
              otpVerified: true,
            },
          }),
        );
        window.location.href = data.data.multipassUrl;
      } else {
        this.handleInvalidOtp();
        document.dispatchEvent(
          new CustomEvent("event:login:otp", {
            detail: {
              method: "phone",
              phone: this.phoneNumber,
              otpVerified: false,
            },
          }),
        );
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      this.validationsElement?.showErrorToast(
        "Error occurred during OTP verification.",
      );
      document
        .querySelector("otp-confirm-button")
        .classList.remove("is-loading");
    }
  }

  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();

      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }

  handleInvalidOtp() {
    this.validationsElement?.showErrorToast("Invalid OTP.");
    document.querySelector("otp-confirm-button").classList.remove("is-loading");
  }

  onVerifySubmit(token) {
    const otp = document.getElementById("otp-validation-input").value;
    const return_to = window.location.href;

    this.callVerifyApi(otp, token, this.sessionId, return_to);
  }

  openBreezeCheckout(multipassUrl) {
    fetch(multipassUrl, { method: "GET", mode: "no-cors" })
      .then(() => document.querySelector("marmeto-checkout-button").click())
      .catch((error) => console.error("Error opening breeze checkout:", error));
  }

  handleGetHelpLink() {
    setTimeout(() => {
      this.validationsElement?.showErrorToast(
        "Please send us an email at hello@cultfit.com",
      );
    }, 2000);
  }
}

customElements.define("sso-login-otp", SsoLoginOtp);

class ResendOtpButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeButton();
  }

  initializeButton() {
    this.setAttribute("data-otp-type", "resend");
    this.addEventListener("click", this.handleResendClick.bind(this));
  }

  handleResendClick() {
    const phoneLogin = document.querySelector("phone-login");

    if (!phoneLogin) {
      console.error("Phone login element not found");
      return;
    }

    const { phoneNumber, validationsElement } = phoneLogin;

    if (!this.isValidPhoneNumber(phoneNumber)) {
      validationsElement.showErrorToast("Invalid phone number for resend.");
      return;
    }

    this.triggerCaptchaResend();
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  triggerCaptchaResend() {
    const captchaButton = document.getElementById("captcha-button");

    if (captchaButton) {
      captchaButton.setAttribute("data-otp-type", "resend");
      captchaButton.click();
    }
  }
}

customElements.define("resend-otp-button", ResendOtpButton);

class TruecallerLogin extends HTMLElement {
  constructor() {
    super();
    this.requestId = "";
    this.returnTo = window.location.href;
    this.intervalId = null;
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.onSubmit.bind(this));
  }

  async getDeepURL() {
    const url = "https://tesseract.cultstore.com/truecaller/oauth/url";
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: this.getDefaultHeaders(),
      });
      if (!response.ok) {
        this.showLoginError();
        return null;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching Truecaller deep URL:", error);
      this.showLoginError();
      return null;
    }
  }

  async callApi() {
    if (!this.requestId) return;

    const url = "https://tesseract.cultstore.com/truecaller/oauth/poll";
    const payload = { requestId: this.requestId, return_to: this.returnTo };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.getDefaultHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        clearInterval(this.intervalId);
        return;
      }

      const data = await response.json();

      if (response.status === 200 && data.data?.multipassUrl) {
        clearInterval(this.intervalId);
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        // dispatch login complete event
        document.dispatchEvent(
          new CustomEvent("event:login:start", {
            detail: {
              method: "truecaller",
              phone: this.phoneNumber,
            },
          }),
        );
        window.location.href = data.data.multipassUrl;
      }
    } catch (error) {
      console.error("Error during Truecaller API call:", error);
      clearInterval(this.intervalId);
      this.showLoginError();
      this.showApiError(error.message);
    }
  }

  async onSubmit() {
    try {
      const response = await this.getDeepURL();
      if (response?.data) {
        this.requestId = response.data.requestId;
        window.location.href = response.data.deepLink;
        this.intervalId = setInterval(() => this.callApi(), 1000);
      }
    } catch (error) {
      console.error("Error during Truecaller login:", error);
      this.showLoginError();
    }
  }

  getDefaultHeaders() {
    const shopifyYCookie = getCookie("_shopify_y");
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Device-ID": shopifyYCookie ?? "",
    };
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Truecaller login failed. Try again later!",
    );
  }

  showApiError(message) {
    document.getElementById("truecaller-response").textContent =
      "Error: " + message;
  }
}

customElements.define("truecaller-login", TruecallerLogin);

class MarmetoCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.customerInfo = null;
    this.checkoutPayload = {};
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.initiateCheckout = this.initiateCheckout.bind(this);
    this.addEventListener("click", this.initiateCheckout);
  }

  async initiateCheckout() {
    try {
      this.toggleLoading(true);
      const customerSession = await this.getCustomerSession();

      if (customerSession?.customer) {
        this.customerInfo = customerSession.customer;

        if (customerSession.phone) {
          await this.prepareCheckoutPayload();
          this.startCheckout();
        } else {
          this.showPhoneUpdateModal();
        }
      } else {
        // this.triggerLoginPopup();
        this.showPhoneUpdateModal();
      }
    } catch (error) {
      console.error("Checkout error:", error);
    } finally {
      this.toggleLoading(false);
    }
  }

  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();

      if (sessionData.customer) {
        this.checkoutPayload = sessionData.breezePayload;
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }

  async prepareCheckoutPayload() {
    try {
      const response = await fetch("/cart.json");
      const cart = await response.json();
      const appliedOffer = JSON.parse(localStorage.getItem("appliedOffer"));

      this.checkoutPayload.payload.cart = cart;
      localStorage.setItem("gaPxCart", JSON.stringify(cart));
      const breezeItemsArray = cart.items.map(item => ({
        id: item.id,
        name: item.title,
        variant: item.variant_id,
        item_brand: item.vendor,
        quantity: item.quantity,
        price: item.price / 100, // Convert to INR
        currency: "INR",
        vendor: item.vendor,
        productType: item.product_type,
      }));
      localStorage.setItem("gaPxCartItems", JSON.stringify(breezeItemsArray));
      if (appliedOffer) {
        this.checkoutPayload.payload.offers = [
          {
            id: appliedOffer.id,
            code: appliedOffer.code,
          },
        ];
      }

      // Determine TAT date based on current time
      const currentISTDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
      const tatHour = 18; // 6 PM IST
      const cutoffHour = 15; // 3 PM IST

      let tatDate;
      if (currentISTDate.getHours() < cutoffHour) {
        // If current time is before 3 PM IST, set TAT to today at 6 PM IST
        tatDate = new Date(currentISTDate.setHours(tatHour, 0, 0, 0));
      } else {
        // If current time is after 3 PM IST, set TAT to tomorrow at 6 PM IST
        tatDate = new Date(currentISTDate.setDate(currentISTDate.getDate() + 1));
        tatDate.setHours(tatHour, 0, 0, 0);
      }

      const formattedDate = tatDate.toISOString().split('T')[0] + 'T18:00:00+05:30';

      this.checkoutPayload.payload.cart.attributes = {
        ...this.checkoutPayload.payload.cart.attributes,
        "FULFILLMENT TAT": formattedDate,
      };

    } catch (error) {
      console.error("Error preparing checkout payload:", error);
      throw new Error("Checkout payload preparation failed");
    }
  }

  startCheckout() {
    try {
      //initiate native blazeSDK if in WebView App
      const isApp = localStorage.getItem("isApp");
      const { android, isWebview } = detectWebview(true);
      if (
        isWebview &&
        isApp &&
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === "function"
      ) {
        let nativePayload = {
          action: "blazeStartNativeCheckout",
          data: {
            ...this.checkoutPayload,
            payload: {
              ...this.checkoutPayload.payload,
              safeMargin: {
                top: android ? 40 : 0,
              },
            },
          },
        };
        const breezeItemsArray = localStorage.getItem("gaPxCartItems")
          ? JSON.parse(localStorage.getItem("gaPxCartItems"))
          : this.checkoutPayload.payload.cart.items.map(item => ({
            id: item.id,
            name: item.title,
            variant: item.variant_id,
            item_brand: item.vendor,
            quantity: item.quantity,
            price: item.price / 100, // Convert to INR
            currency: "INR",
            vendor: item.vendor,
            productType: item.product_type,
          }));
        window.gtag('event', 'begin_checkout', {
          send_to: "G-ZWHZKTYB0D",
          currency: "INR",
          value: this.checkoutPayload.payload.cart.total_price,
          items: breezeItemsArray, // Prepare an array of items in the cart
          breeze_event_type: 'breeze_checkout_initiated',
          breeze_event_time: new Date().toISOString()
        });
        window.fbq(
          'track',
          "InitiateCheckout",
          {
            content_type: 'product_group',
          value: this.checkoutPayload.payload.cart.total_price / 100,
            content_ids: breezeItemsArray.map(item => item.id),
            contents: breezeItemsArray,
            num_items: breezeItemsArray.length,
            currency: "INR",
          },
          {
            eventID: `breeze_checkout_${Date.now()}`,
          }
        );
        window.ReactNativeWebView.postMessage(JSON.stringify(nativePayload));
        console.log("Payload Sent");
      } else if (window.BlazeSDK && this.checkoutPayload) {
        this.handlePushState();
        window.BlazeSDK.process(this.checkoutPayload);
      } else {
        throw new Error("Blaze SDK unavailable or payload missing");
      }
    } catch (error) {
      console.error("Checkout rendering error:", error);
    }
  }

  triggerLoginPopup() {
    const loginModal = document.querySelector("sso-login");

    if (loginModal) {
      document.querySelector("sso-login").togglePopup();
      sessionStorage.setItem("openCheckout", "true");
    }
  }

  showPhoneUpdateModal() {
    const phoneUpdateModal = document.querySelector("#cart-drawer-login-body");
    const cartDrawerLoginModal = document.querySelector("cart-drawer-login");
    const cartDrawerTruecaller = document.querySelector(
      "cart-drawer-truecaller-login",
    );

    if (cartDrawerLoginModal) {
      cartDrawerLoginModal.classList.add("active");
    }
    if (phoneUpdateModal) {
      if (this.isAndroid) {
        cartDrawerTruecaller.classList.remove("hidden");
        cartDrawerTruecaller.checkAndOpenTruecaller();
      }
      phoneUpdateModal.classList.add("active");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("disabled", "true");
      sessionStorage.setItem("openCheckout", "true");
    }
  }

  toggleLoading(isLoading) {
    this.classList.toggle("is-loading", isLoading);
    this.style.disable = isLoading;
    this.style.cursor = isLoading ? "not-allowed" : "pointer";
    this.style.pointerEvents = isLoading ? "none" : "auto";
    this.style.opacity = isLoading ? "0.5" : "1";
    this.style.transition = "opacity 0.3s ease-in-out";
  }

  handlePushState() {
    const currentUrl = window.location.href;
    history.pushState(null, "", currentUrl);

    window.onpopstate = function () {
      window.location.reload();
    };
  }
}

customElements.define("marmeto-checkout-button", MarmetoCheckoutButton);

class GoogleLogin extends HTMLElement {
  constructor() {
    super();
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.handleLogin.bind(this));
  }

  async handleLogin() {
    try {
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(
        "https://tesseract.cultstore.com/google/oauth/url",
        {
          headers: {
            "X-Device-ID": shopifyYCookie ?? "",
          },
        },
      );

      if (!response.ok) {
        this.showLoginError();
        return;
      }

      const data = await response.json();

      if (data?.success && data?.data) {
        window.location.href = data.data;
      } else {
        this.showLoginError();
      }
    } catch (error) {
      console.error("Google login error:", error);
      this.showLoginError();
    }
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Google login failed. Try again later!",
    );
  }
}

customElements.define("google-login", GoogleLogin);

function onSubmit(token) {
  // Helper function to process phone login components
  function handlePhoneLogin(selector, buttonSelector) {
    const phoneLogin = document.querySelector(selector);
    const phoneLoginButton = document.querySelector(buttonSelector);

    // Proceed if the button is not disabled
    if (phoneLoginButton && !phoneLoginButton.hasAttribute("disabled")) {
      if (phoneLogin) {
        phoneLogin.handleRecaptchaToken(token); // Handle the token
      } else {
        phoneLoginButton.classList.remove("is-loading"); // Ensure loading state is reset
        phoneLoginButton.removeAttribute("disabled");
      }
    }
  }

  // Handle both phone login components
  handlePhoneLogin(
    "cart-drawer-phone-login",
    ".cart-drawer-phone-login-button",
  );
  handlePhoneLogin("phone-login", ".phone-login-button");
}

function onVerifySubmit(token) {
  // Helper function to process OTP components
  function handleOtpLogin(selector) {
    const otpComponent = document.querySelector(selector);
    const confirmButton = otpComponent?.querySelector(".otp--confirm__button");

    // Proceed if the confirm button is not disabled
    if (confirmButton && !confirmButton.hasAttribute("disabled")) {
      otpComponent.onVerifySubmit(token); // Handle the token
    }
  }

  // Handle both OTP components
  handleOtpLogin("cart-drawer-login-otp");
  handleOtpLogin("sso-login-otp");
}

// cart drawer login
class CartDrawerPhoneLogin extends HTMLElement {
  constructor() {
    super();
    this.phoneNumber = "";
    this.countryCode = "";
    this.sessionId = "";
    this.validationsElement = null;
  }

  connectedCallback() {
    this.initPhoneLogin();
  }

  initPhoneLogin() {
    this.validationsElement = document.querySelector("sso-login-validations");
    const inputField = this.querySelector('input[id="cartDrawerPhoneNumber"]');
    const continueButton = this.querySelector(
      ".cart-drawer-phone-login-button",
    );
    const captchaButton = document.getElementById("cart-drawer-captcha-button");
    // const otpOnCallButton = document.querySelector('cart-drawer-otp-on-call');

    this.disableButton(continueButton);
    inputField.addEventListener("input", () =>
      this.validatePhoneNumber(inputField, continueButton),
    );

    continueButton.addEventListener("click", (event) =>
      this.handleContinueClick(event, captchaButton, continueButton),
    );
    // otpOnCallButton.addEventListener('click', (event) => this.handleOtpOnCall(event, captchaButton));
  }

  handleContinueClick(event, captchaButton, continueButton) {
    event.preventDefault();
    this.toggleButtonState(continueButton, true);
    this.countryCode = this.querySelector(
      'input[id="cartDrawerCountryCode"]',
    ).value.trim();
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.sendOtpRequest(captchaButton, "send");
    } else {
      this.showError("Invalid phone number.", continueButton);
    }
  }

  // handleOtpOnCall(event, captchaButton) {
  //   event.preventDefault();
  //   this.sendOtpRequest(captchaButton, 'call');
  // }

  sendOtpRequest(captchaButton, otpType) {
    captchaButton.setAttribute("data-otp-type", otpType);
    captchaButton.click();
  }

  validatePhoneNumber(inputField, continueButton) {
    this.phoneNumber = inputField?.value.trim();
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.enableButton(continueButton);
    } else {
      this.disableButton(continueButton);
    }
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  async handleRecaptchaToken(token) {
    const captchaButton = document.getElementById("cart-drawer-captcha-button");
    const otpType = captchaButton.getAttribute("data-otp-type") || "send";

    try {
      await this.callApi(this.phoneNumber, token, this.countryCode, otpType);
    } catch (error) {
      console.error("ReCAPTCHA validation failed:", error);
      this.validationsElement.showErrorToast("ReCAPTCHA validation failed.");
      this.toggleButtonState(".cart-drawer-phone-login-button", false);
    } finally {
      captchaButton.removeAttribute("data-otp-type");
    }
  }
  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();
      if (sessionData.customer) {
        return sessionData;
      }
      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }
  async callApi(phone, captcha, countryCode, otpType) {
    otpType = otpType || "sms";
    const continueButton = this.querySelector(
      ".cart-drawer-phone-login-button",
    );

    const customerSession = await this.getCustomerSession();
    const shopifyYCookie = getCookie("_shopify_y");
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Device-ID": shopifyYCookie ?? "",
      },
      body: JSON.stringify({
        phone,
        countryCode,
        captcha,
        medium: otpType,
        cfUserId: customerSession?.cfUserId,
      }),
    };

    try {
      let url = "";
      if (!customerSession?.customer) {
        url = "https://tesseract.cultstore.com/phone/otp/send";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        const cfUserId = customerSession?.cfUserId;
        url = "https://tesseract.cultstore.com/phone/update/otp/send";
      } else {
        // todo:: log and report error here
        return;
      }
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(
          data.error || data.message || "Error occurred during OTP request.",
        );
      }
      this.sessionId = data?.data?.session_id || "";

      this.toggleButtonState(continueButton, false);
      this.handleOtpSuccess(otpType);
    } catch (error) {
      console.error("Phone login/update error:", error);
      this.validationsElement.showErrorToast(error.message);
      this.toggleButtonState(continueButton, false);
    }
  }

  handleOtpSuccess(otpType) {
    let successMessage = "";
    switch (otpType) {
      case "resend":
        successMessage =
          "OTP has been resent to your phone number. Please check!";
        break;
      case "call":
        successMessage = "You will receive OTP on call shortly!";
        break;
      case "send":
      default:
        successMessage = "OTP sent successfully!";
        break;
    }
    this.validationsElement.showSuccessToast(successMessage);
    this.navigateToOtp(this.phoneNumber, this.sessionId);
  }

  toggleButtonState(button, isLoading) {
    button.classList.toggle("is-loading", isLoading);
  }

  disableButton(button) {
    button?.setAttribute("disabled", "true");
  }

  enableButton(button) {
    button?.removeAttribute("disabled");
  }

  showError(message, button) {
    this.validationsElement.showErrorToast(message);
    this.toggleButtonState(button, false);
  }

  navigateToOtp(phoneNumber, sessionId) {
    const ssoLoginContainer = document.getElementById("cart-drawer-login-body");
    const ssoLoginOtp = document.querySelector("cart-drawer-login-otp");
    if (ssoLoginContainer && ssoLoginOtp) {
      ssoLoginContainer.classList.remove("active");
      ssoLoginOtp.classList.add("active");
      this.querySelector('input[name="phone-number"]').value = "";

      ssoLoginOtp.setPhoneNumber(sessionId);
    }
  }
}

customElements.define("cart-drawer-phone-login", CartDrawerPhoneLogin);

class CartDrawerLoginOtp extends HTMLElement {
  constructor() {
    super();
    this.otpDigits = [];
    this.sessionId = "";
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.initOtpListeners();
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    if (otpValidationInput) {
      otpValidationInput.focus(); // Ensure hidden input is the autofill target
    }
  }

  initOtpListeners() {
    const backButton = this.querySelector(".back--button");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    const confirmButton = this.querySelector(".otp--confirm__button");
    const getHelpLink = this.querySelector(".get--help__link");

    otpHolders.forEach((holder, index) =>
      this.setupOtpHolder(holder, index, otpHolders, otpValidationInput),
    );

    // Listen for input events on the hidden input for autofill handling
    otpValidationInput.addEventListener("input", () =>
      this.handleOtpAutofill(otpValidationInput, otpHolders),
    );

    backButton?.addEventListener("click", this.handleBackButton.bind(this));
    confirmButton?.addEventListener(
      "click",
      this.handleConfirmButton.bind(this),
    );
    getHelpLink?.addEventListener("click", this.handleGetHelpLink.bind(this));
  }

  setupOtpHolder(holder, index, otpHolders, otpValidationInput) {
    holder.setAttribute("inputmode", "numeric");
    holder.setAttribute("autocomplete", "one-time-code");
    holder.style.caretColor = "black";
    holder.style.cursor = "text";

    holder.addEventListener("input", (event) =>
      this.handleOtpInput(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("keydown", (event) =>
      this.handleOtpBackspace(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("paste", (event) =>
      this.handleOtpPaste(event, otpHolders, otpValidationInput),
    );
  }

  handleOtpAutofill(otpValidationInput, otpHolders) {
    const otp = otpValidationInput.value.trim();
    if (/^\d{6}$/.test(otp)) {
      this.otpDigits = otp.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last field for UX
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpPaste(event, otpHolders, otpValidationInput) {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    if (/^\d{6}$/.test(paste)) {
      this.otpDigits = paste.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus();
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpInput(event, index, otpHolders, otpValidationInput) {
    const input = event.target.value.trim();

    if (index === 0 && /^\d{6}$/.test(input)) {
      // If the first input receives a 6-digit OTP (autofill case), distribute it
      this.otpDigits = input.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last input for UX
    } else if (/^\d$/.test(input)) {
      // If the input is a single digit, handle it normally
      this.otpDigits[index] = input;
      if (index < otpHolders.length - 1) {
        otpHolders[index + 1].focus(); // Move focus to the next field
      }
    } else {
      // If the input is invalid, clear the field
      event.target.value = "";
      this.otpDigits[index] = "";
    }

    this.updateOtpValue(otpValidationInput);
  }

  handleOtpBackspace(event, index, otpHolders, otpValidationInput) {
    if (event.key === "Backspace") {
      if (event.target.value) {
        event.target.value = "";
        this.otpDigits[index] = "";
      } else if (index > 0) {
        otpHolders[index - 1].focus();
        otpHolders[index - 1].value = "";
        this.otpDigits[index - 1] = "";
      }
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleBackButton() {
    const ssoLoginContainer = document.getElementById("cart-drawer-login-body");
    const phoneLogin = document.querySelector("cart-drawer-phone-login");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    const cartDrawerInputField = document.getElementById(
      "cartDrawerPhoneNumber",
    );
    const cartDrawerContinueButton = document.querySelector(
      ".cart-drawer-phone-login-button",
    );

    if (ssoLoginContainer) {
      ssoLoginContainer.classList.add("active");
      this.classList.remove("active");
      phoneLogin?.validatePhoneNumber(
        cartDrawerInputField,
        cartDrawerContinueButton,
      );

      this.otpDigits = this.otpDigits || new Array(otpHolders.length).fill("");
      otpHolders.forEach((holder, index) => {
        holder.value = "";
        this.otpDigits[index] = "";
      });
      otpValidationInput.value = "";
      this.toggleConfirmButton(true);
    }
  }

  handleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    if (confirmButton.hasAttribute("disabled")) return;

    confirmButton.classList.add("is-loading");
    document.querySelector("#cart-drawer-verify-otp-form .g-recaptcha").click();
  }

  setPhoneNumber(sessionId) {
    this.sessionId = sessionId;
  }

  updateOtpValue(otpValidationInput) {
    otpValidationInput.value = this.otpDigits.join("");
    this.toggleConfirmButton();
  }

  toggleConfirmButton(disable = false) {
    const confirmButton = this.querySelector(".otp--confirm__button");
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );

    if (disable || otpValidationInput.value.length !== 6) {
      confirmButton.setAttribute("disabled", "true");
    } else {
      confirmButton.removeAttribute("disabled");
    }
  }

  async callVerifyApi(otp, captcha, sessionId, return_to) {
    const customerSession = await this.getCustomerSession();
    try {
      let url = "";
      if (!customerSession?.customer) {
        url = "https://tesseract.cultstore.com/phone/otp/verify";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        url = "https://tesseract.cultstore.com/phone/update/otp/verify";
      } else {
        // todo:: log and report error here
        return;
      }
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Device-ID": shopifyYCookie ?? "",
        },
        body: JSON.stringify({
          otp,
          captcha,
          sessionId,
          return_to,
          cfUserId: customerSession?.cfUserId,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error("Network response was not ok");

      if (data.success) {
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        window.location.href = data.data.multipassUrl;
      } else {
        this.handleInvalidOtp();
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      this.validationsElement?.showErrorToast(
        "Error occurred during OTP verification.",
      );
      document
        .querySelector("cart-drawer-otp-confirm-button")
        .classList.remove("is-loading");
    }
  }

  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();

      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }

  handleInvalidOtp() {
    this.validationsElement?.showErrorToast("Invalid OTP.");
    document
      .querySelector("cart-drawer-otp-confirm-button")
      .classList.remove("is-loading");
  }

  onVerifySubmit(token) {
    const otp = document.getElementById(
      "cart-drawer-otp-validation-input",
    ).value;
    const return_to = window.location.href;

    this.callVerifyApi(otp, token, this.sessionId, return_to);
  }

  openBreezeCheckout(multipassUrl) {
    fetch(multipassUrl, { method: "GET", mode: "no-cors" })
      .then(() => document.querySelector("marmeto-checkout-button").click())
      .catch((error) => console.error("Breeze checkout opening error:", error));
  }
}

customElements.define("cart-drawer-login-otp", CartDrawerLoginOtp);

class CartDrawerResendOtpButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeButton();
  }

  initializeButton() {
    this.setAttribute("data-otp-type", "resend");
    this.addEventListener("click", this.handleResendClick.bind(this));
  }

  handleResendClick() {
    const phoneLogin = document.querySelector("cart-drawer-phone-login");

    if (!phoneLogin) {
      console.error("Phone login element not found");
      return;
    }

    const { phoneNumber, validationsElement } = phoneLogin;

    if (!this.isValidPhoneNumber(phoneNumber)) {
      validationsElement.showErrorToast("Invalid phone number for resend.");
      return;
    }

    this.triggerCaptchaResend();
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  triggerCaptchaResend() {
    const captchaButton = document.getElementById("cart-drawer-captcha-button");

    if (captchaButton) {
      captchaButton.setAttribute("data-otp-type", "resend");
      captchaButton.click();
    }
  }
}

customElements.define(
  "cart-drawer-resend-otp-button",
  CartDrawerResendOtpButton,
);

class CartDrawerTruecallerLogin extends HTMLElement {
  constructor() {
    super();
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.requestId = "";
    this.returnTo = window.location.href;
    this.intervalId = null;
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.onSubmit.bind(this));
  }

  checkAndOpenTruecaller() {
    let isTruecallerInstalled = false;
    const truecallerURL = "truecaller://";
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = truecallerURL;
    document.body.appendChild(iframe);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (isTruecallerInstalled) {
          this?.onSubmit();
        }
        document.body.removeChild(iframe);
      }, 500);
    });

    window.addEventListener(
      "blur",
      () => {
        isTruecallerInstalled = true;
      },
      { once: true },
    );
  }

  async getDeepURL() {
    const url = "https://tesseract.cultstore.com/truecaller/oauth/url";
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: this.getDefaultHeaders(),
      });
      if (!response.ok) {
        this.showLoginError();
        return null;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching deep URL for Truecaller:", error);
      this.showLoginError();
      return null;
    }
  }

  async callApi() {
    if (!this.requestId) return;

    const url = "https://tesseract.cultstore.com/truecaller/oauth/poll";
    const payload = { requestId: this.requestId, return_to: this.returnTo };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.getDefaultHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        clearInterval(this.intervalId);
        return;
      }

      const data = await response.json();
      if (response.status === 200 && data.data?.multipassUrl) {
        clearInterval(this.intervalId);
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        window.location.href = data.data.multipassUrl;
      }
    } catch (error) {
      console.error("Error polling Truecaller API:", error);
      clearInterval(this.intervalId);
      this.showLoginError();
      this.showApiError(error.message);
    }
  }

  async onSubmit() {
    try {
      const response = await this.getDeepURL();
      if (response?.data) {
        this.requestId = response.data.requestId;
        window.location.href = response.data.deepLink;
        this.intervalId = setInterval(() => this.callApi(), 1000);
      }
    } catch (error) {
      console.error("Error during Truecaller login submission:", error);
      this.showLoginError();
    }
  }

  getDefaultHeaders() {
    const shopifyYCookie = getCookie("_shopify_y");
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Device-ID": shopifyYCookie ?? "",
    };
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Truecaller login failed. Try again later!",
    );
  }

  showApiError(message) {
    document.getElementById("cart-drawer-truecaller-response").textContent =
      "Error: " + message;
  }
}

customElements.define(
  "cart-drawer-truecaller-login",
  CartDrawerTruecallerLogin,
);
